<template>
  <div class="users">
    <div class="users--title fs-25 black--text font-weight-medium">
      Users
    </div>
    <div class="users-body mt-4" :class="{ 'mt-7': xsOrsm }">
      <div
        class="users-body__header mb-6 d-sm-flex justify-space-between align-center"
        :class="{ 'text-center': xsOrsm }"
      >
        <div class="users-body__header__content">
          <div class="users-body__header__content--title">Want to add a new User?</div>
          <div class="users-body__header__content--subtitle">Click on the following button to add a new user</div>
        </div>
        <div class="users-body__header__button" :class="{ 'mt-4': xsOrsm }">
          <v-btn
            width="255"
            color="button-primary"
            :loading="loading"
            large
            class="white--text"
            @click="showAddUserModal = true"
          >
            <span class="font-weight-bold fs-15">Add New User</span>
          </v-btn>
        </div>
      </div>
      <v-divider class="mb-6"></v-divider>
      <div class="users-body__search mb-6" :class="searchWidth">
        <DashboardSearch
          text-label="Search User"
          description="Enter User details that you want to search"
          @dashboard-search="dashboardSearchActionHandler"
        />
      </div>
      <v-row class="loader fill-height mt-8 py-6" align="center" justify="center" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
      <div class="users-body__list" v-else>
        <div v-for="user in users" :key="user.id" class="mb-4">
          <UserInfoCard :item="user" @user-info-card="userInfoCardActionHandler" />
        </div>
      </div>
    </div>
    <ConfirmDeleteDialog
      v-if="showDeleteConfirmationDialog"
      @clicked-yes="deleteUser"
      @clicked-no="showDeleteConfirmationDialog = false"
      :isAddUserFormLoading="loading"
      :loader="isDeleting"
      :name="user.name"
      :id="user.id"
    />
    <AddUserModal
      max-width="800"
      v-if="showAddUserModal"
      :isAddUserFormLoading="loading"
      @add-user-modal="addNewUser"
      @cancel-user-modal="showAddUserModal = false"
    />
  </div>
</template>
<script>
import DashboardSearch from "@/modules/DashboardModule/components/DashboardSearch";
import UserInfoCard from "@/modules/DashboardModule/components/UserInfoCard";
import AddUserModal from "@/modules/DashboardModule/components/AddUserModal";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "Users",
  components: {
    DashboardSearch,
    UserInfoCard,
    AddUserModal,
    ConfirmDeleteDialog
  },
  data() {
    return {
      showAddUserModal: false,
      showDeleteConfirmationDialog: false,
      users: [],
      isDeleting: false,
      loading: false,
      originalUsers: [],
      user: {
        id: 0,
        name: "",
        email: "",
        action: "add"
      }
    };
  },
  mounted() {
    this.getUsers();
  },
  mixins: [commonMethodsMixin],
  methods: {
    dashboardSearchActionHandler(searchedString) {
      this.users = [...this.originalUsers];
      if (searchedString === "") {
        return;
      }
      this.users = this.users.filter(user => {
        return searchedString
          .toLowerCase()
          .split(" ")
          .every(v => user.name.toLowerCase().includes(v) || user.email.toLowerCase().includes(v));
      });
    },
    userInfoCardActionHandler(data) {
      if (data && data.action == "edit") {
        // call "EDIT" function here
        const user = data.user;
        user.action = "edit";
        this.user = user;
        this.showAddUserModal = true;
      } else if (data && data.action == "delete") {
        const user = data.user;
        user.action = "delete";
        this.user = user;
        this.showDeleteConfirmationDialog = true;
      }
    },
    deleteUser(id) {
      this.isDeleting = true;
      this.$store
        .dispatch(AT.DELETE_USER, id)
        .then(() => {
          this.users.splice(
            this.users.findIndex(user => user.id === id),
            1
          );
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isDeleting = false;
          this.showDeleteConfirmationDialog = false;
        });
    },
    addNewUser(user) {
      this.loading = true;
      const formData = {
        name: user.name,
        email: user.email
      };
      this.$store
        .dispatch(AT.ADD_USER, formData)
        .then(res => {
          if (res && res.data) {
            const user = {
              id: res.data.id,
              email: res.data.email,
              name: res.data.name
            };
            this.users.push(user);
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.loading = false;
          this.showAddUserModal = false;
        });
    },
    confirmDialogHandler() {
      this.confirmDialog = true;
    },
    getUsers() {
      this.loading = true;
      this.$store
        .dispatch(AT.GET_USERS)
        .then(res => {
          if (res) {
            this.users = res.data;
            this.originalUsers = res.data;
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.users-body {
  .v-divider {
    border-top-width: 2px;
  }
  &__header {
    &__content {
      &--title {
        font-size: 20px;
        font-weight: 500;
      }
      &--subtitle {
        font-size: 15px;
      }
    }
  }
  &__search {
    margin: auto;
  }
}
</style>
